module.exports = __webpack_public_path__ + "img/Rectangle_32.2639fa6c.svg";